export default __webpack_public_path__ + "static/Map-5d7c7d0659780481fd71e7f02b917c15.png";